/**
 * @generated SignedSource<<62e09952c60e2e85eabb7118805a6b3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type messageBody_AtlassianSearchPage$data = {
  readonly entity: {
    readonly description?: string | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"channel_AtlassianSearchPage" | "mention_AtlassianSearchPage_UserMention">;
  readonly " $fragmentType": "messageBody_AtlassianSearchPage";
};
export type messageBody_AtlassianSearchPage$key = {
  readonly " $data"?: messageBody_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageBody_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "description"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "messageBody_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "mention_AtlassianSearchPage_UserMention"
    },
    {
      "kind": "FragmentSpread",
      "name": "channel_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "ExternalMessage"
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "ExternalConversation"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "24e4e9e72573cfcbb15c7aca65aa13b6";

export default node;
